import { render, staticRenderFns } from "./deleteCustom.vue?vue&type=template&id=3a2aa914&scoped=true&"
import script from "./deleteCustom.vue?vue&type=script&lang=js&"
export * from "./deleteCustom.vue?vue&type=script&lang=js&"
import style0 from "./deleteCustom.vue?vue&type=style&index=0&id=3a2aa914&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a2aa914",
  null
  
)

export default component.exports